import React from "react";

interface MarkdownSkeletonProps {
  className?: string;
}

const MarkdownSkeleton: React.FC<MarkdownSkeletonProps> = ({ className = "" }) => {
  return (
    <div className={`${className}`}>
      {/* Header skeleton */}
      <div className="mb-8">
        <div className="skeleton skeleton-title w-3/4"></div>
        <div className="skeleton skeleton-text w-1/2"></div>
      </div>

      {/* Content skeleton */}
      <div className="space-y-6">
        {/* Paragraphs */}
        {Array.from({ length: 4 }).map((_, index) => (
          <div key={index} className="space-y-2">
            <div className="skeleton skeleton-paragraph w-full"></div>
            <div className="skeleton skeleton-paragraph w-5/6"></div>
            <div className="skeleton skeleton-paragraph w-4/6"></div>
          </div>
        ))}

        {/* Subtitle */}
        <div className="pt-4">
          <div className="skeleton skeleton-title w-1/3 mb-3"></div>
          <div className="skeleton skeleton-paragraph w-full"></div>
          <div className="skeleton skeleton-paragraph w-3/4 mt-2"></div>
        </div>

        {/* List */}
        <div className="space-y-2">
          <div className="skeleton skeleton-text w-1/4"></div>
          {Array.from({ length: 3 }).map((_, index) => (
            <div key={index} className="skeleton-list-item">
              <div className="skeleton skeleton-bullet"></div>
              <div className="skeleton skeleton-paragraph w-2/3"></div>
            </div>
          ))}
        </div>

        {/* Another paragraph */}
        <div className="space-y-2">
          <div className="skeleton skeleton-paragraph w-full"></div>
          <div className="skeleton skeleton-paragraph w-4/5"></div>
        </div>

        {/* Code block skeleton */}
        <div className="bg-gray-50 rounded-lg p-4 border border-gray-100">
          <div className="space-y-2">
            <div className="skeleton skeleton-paragraph w-1/4"></div>
            <div className="skeleton skeleton-paragraph w-3/4"></div>
            <div className="skeleton skeleton-paragraph w-1/2"></div>
          </div>
        </div>

        {/* Final paragraphs */}
        <div className="space-y-2">
          <div className="skeleton skeleton-paragraph w-full"></div>
          <div className="skeleton skeleton-paragraph w-5/6"></div>
          <div className="skeleton skeleton-paragraph w-3/4"></div>
        </div>
      </div>
    </div>
  );
};

export default MarkdownSkeleton; 